import { produce } from 'immer';

import type { State } from '../store';
import type { Comment } from '~/types/comment';
import { useStore } from '../store';

export const addComments = (comments: Comment[]) => {
  useStore.setState(state =>
    produce(state, draft => {
      const commentsMap = comments.reduce<State['comments']>((acc, current) => {
        acc[current.id] = current;
        return acc;
      }, {});

      draft.comments = { ...draft.comments, ...commentsMap };
    })
  );
};

export const addComment = (comment: Comment) => {
  addComments([comment]);
};
